import "./banners.css";
import banner1 from '../../../../assets/imgs/banners-home/banner1.png';
import banner2 from '../../../../assets/imgs/banners-home/banner2.png';
import banner3 from '../../../../assets/imgs/banners-home/banner3.jpg';
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import { useEffect, useState } from "react";

function Banners() {
  let currentLng = "es";
  localStorage.getItem("lng") ? currentLng = `${localStorage.getItem("lng")}` : currentLng = 'es';
  const [index, setIndex] = useState(0);
  const slides_es = [
    {
      img: banner1,
      title: "PUNTO CARGO - ¡Tu envío, sin complicaciones!",
      desc: "Mensajería y paquetería de hasta 10 kg desde MTY y BJX a más de 35 destinos nacionales. Entrega garantizada al día siguiente* o en 48 h con conexión. Desde tu tienda de viaje, con embalaje incluido y pago fácil.",
    },
    {
      img: banner2,
      title: "Entrega garantizada",
      desc: "Servicio express en menos de 24 horas...",
    },
    {
      img: banner3,
      title: "Cobertura nacional",
      desc: "Llegamos a más de 35 destinos nacionales...",
    },
  ];

  const slides_en = [
    {
      img: banner1,
      title: "PUNTO CARGO - Your shipment, hassle-free!",
      desc: "Courier and parcel delivery up to 10kg from Monterrey and Benito Juárez to over 35 national destinations. Guaranteed next-day delivery* or within 48 hours with internet access. From your travel store, with packaging included and easy payment.",
    },
    {
      img: banner2,
      title: "Guaranteed delivery",
      desc: "Express service in less than 24 hours...",
    },
    {
      img: banner3,
      title: "National coverage",
      desc: "We reach more than 35 national destinations...",
    },
  ];

  let slides = [];

  if(currentLng === 'es') {
    slides = slides_es;
  } else {
    slides = slides_en;
  }



  const prevSlide = () => {
    setIndex((old) => (old === 0 ? slides.length - 1 : old - 1));
  };

  const nextSlide = () => {
    setIndex((old) => (old === slides.length - 1 ? 0 : old + 1));
  };

  const goToSlide = (i) => {
    setIndex(i);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 10000);

    return () => clearInterval(interval);
  }, [index]);

  return(
    <>
      <div className="slide-container">
        <div className="arrow-left" onClick={prevSlide}><FaArrowLeftLong /></div>
        
        <div 
          className="slides-wrapper" 
        >
          {slides.map((slide, i) => (
            <div className={`slide ${index === i ? "active" : ""}`} key={i}>
              <img src={slide.img} alt="image" />
              <div className="bg-black-slide"></div>
              <div className="text-container">
                <h2>{slide.title}</h2>
                <p>{slide.desc}</p>

                <button>{currentLng === "es" ? "Ver más" : "See more"}</button>
              </div>
            </div>
          ))}
        </div>

        <div className="arrow-right" onClick={nextSlide}><FaArrowRightLong /></div>

        <div className="index-slide">
          {slides.map((_, i) => (
            <div 
              key={i} 
              className={`circle ${index === i ? "active" : ""}`} 
              onClick={() => goToSlide(i)}
              ></div>
          ))}
        </div>
      </div>
    </>
  )
}

export default Banners;